<template>
  <div  class="submit-dialog">
    <el-dialog
      append-to-body
      title="保存剪辑"
      :close-on-click-modal="false"
      :visible.sync="isSaveOrSubmit"
      :before-close="handleDialogClose"
     v-loading.fullscreen.lock="isLoading"
    >
      <el-row>
        <el-form
            v-loading="isLoadingSelect"
            ref="form"
            :model="form"
            label-position="left"
            label-width="112px"
            :rules="rules"
            hide-required-asterisk
          >
        <el-form-item label="预览">
        <div class="submit-video-container"  :style="{width:videoFrame.width + 'px',height:videoFrame.height + 'px'}">
          <div
            v-loading="isVideoLoading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
          >
            <canvas
              id="canvasBackImage"
              ref="canvasBackImage"
            >
            </canvas>
          </div>
          <videoDrr
            v-for="(item, index) in realVideoList"
            :key="'videoDrr' + index"
            ref="videoDrr"
            class="resizable-container"
            :track-index="index"
            :track-list="item"
            :is-submit="true"
            :videoPlay="true"
            :submit-playing="playingPicture"
            :submit-playing-index="playingPictureIndex"
          >
          </videoDrr>
          <pictureDrr
            v-for="(item, index) in realPictureList"
            :key="'pictureDrr' + index"
            ref="pictureDrr"
            class="resizable-container"
            :track-index="index"
            :track-list="item"
            :is-submit="true"
            :submit-playing="playingPicture"
            :submit-playing-index="playingPictureIndex"
          ></pictureDrr>

        </div>
        <el-col>
           <VideoControls
            :video-play="videoPlay"
            :track-duration="trackDuration"
            :track-current-time="trackCurrentTime"
            @video-play="handleVideoPlay"
            @video-pause="handleVideoPause"
            @slider-change="handleSliderChange"
          ></VideoControls>
        </el-col>
        </el-form-item>
         <el-col>
            <el-form-item label="物料名称" prop="materialName">
              <el-input v-model="form.materialName" maxlength="45"></el-input>
            </el-form-item>
        </el-col>
          </el-form>
      </el-row>
      <span style="color:#ff8b00"> TIPS:视频尺寸超出广告投放标准，确认保存后将压缩视频</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button
          v-loading="loadingSave"
          type="primary"
          @click="handleSubmitValid"
          >确认保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pictureDrr from './drrContainers/pictureDrr'
import textDrr from './drrContainers/textDrr'
import VideoControls from './VideoControls'
import Various from './global/various'
import { formatDuration } from '@/utils/smartCreation'
import { mapState } from 'vuex'
import videoDrr from './drrContainers/videoDrr'
export default {
  components: {
    pictureDrr,
    textDrr,
    VideoControls,
    videoDrr
  },
  props: {
    isSaveOrSubmit: {
      type: Boolean,
      default: false
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    saveOrSubmit: {
      type: Number,
      default: 0
    },
    formInfo: {
      type: Object,
      default: function () {}
    },
    videoFrame: {
      type: Object,
      default: function () {}
    },
    addedMaterialList: {
      type: Array,
      default: function () {}
    },
    selectedMaterialList: {
      type: Array,
      default: function () {}
    },
    selectedPictureList: {
      type: Array,
      default: function () {}
    },
    trackDurationString: {
      type: String,
      default: '00:00:00'
    },
    spaceId: {
      type: Number
    },
    backImageList: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      dialogTitle: '',
      isVideoLoading: false,
      videoSrc: '',
      submitVideo: undefined,
      currentTime: 0,
      lastPlayedMaterial: {},
      playingMaterial: {},
      playingPicture: [],
      playingText: [],
      playingTransition: {},
      playingPictureIndex: [],
      playingTextIndex: [],
      videoPlay: false,
      trackCurrentTime: 0,
      trackCurrentTimeString: '00:00:00',
      trackDuration: 0,
      controlsIcons: {
        play: require('../../assets/onlineClip/play.png'),
        pause: require('../../assets/onlineClip/pause.png')
      },
      coverList: [],
      mediaImageUploadUrl: 'api/uploadHomeImgV2.html',
      form: {
        // editId: '',
        materialName: '',
        resourceId: '', // 背景图资源id
        spaceId: '', // 广告位id
        video: [], // 视频
        watermarkList: []
      },
      rules: {
        materialName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ]
      },
      loadingPicH: false,
      loadingPicV: false,
      loadingSave: false,
      isLoading: false,
      isLoadingSelect: false,
      unsupportSubmit: false,
      realSelectedList: [],
      realAddedList: [],
      realPictureList: [],
      realTextList: [],
      realVideoList: [[]],
      realTransitionList: Various.transitionList,
      isEnd: false,
      tracks: [
        {
          target: 'playingMaterial',
          list: 'realSelectedList'
        },
        {
          target: 'playingPicture',
          list: 'realPictureList'
        }
      ],
      canvasWidth: 100,
      canvasVideo: null,
      canvasTimer: null,
      widthScale: 0,
      heightScale: 0,
      oldPictureIndex: null,
      canvasBackImage: null
    }
  },
  computed: {
    ...mapState({
      pictureTrackList: state => state.pictureTrackList,
      textTrackList: state => state.textTrackList,
      videoReource: state => state.videoReource,
      backZoom: state => state.backZoom
    })
  },
  watch: {
    unsupportSubmit: function (val) {
      if (val) {
        this.handleDialogClose()
      }
    },
    selectedMaterialList: function (val, oldValue) {
      if (!val) {
        this.$message('未获取到轨道素材信息，请重新保存或提交')
        this.$emit('submit-close')
      }
    },
    playingPicture: function (val) {
      // 避免视频贴图的卡顿以及不同视频贴图切换时所导致的骤停报错问题
      if (this.oldPictureIndex === this.playingPictureIndex[0]) {
        return true
      }
      this.oldPictureIndex = this.playingPictureIndex[0]
      if (val[0] && val[0].fileType === 'video') {
        if (this.videoPlay) {
          this.playVideoPicture(val[0], true)
        } else {
          this.playVideoPicture(val[0], false)
        }
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.$emit('submit-close')
    },
    handleVideoPlayOrPause() {
      if (this.videoPlay) {
        this.handleVideoPause()
      } else {
        this.handleVideoPlay()
      }
    },
    handleVideoPlaying() {
      if (!this.videoPlay) {
        return false
      }
      if (this.trackCurrentTime >= this.trackDuration) {
        this.trackCurrentTime = 0
        this.isEnd = true
      }
      if (
        !this.form.firstVideoH &&
        this.videoSrc === this.realSelectedList[0].resourceUrl
      ) {
        this.form.firstVideoH = this.submitVideo.videoWidth
        this.form.firstVideoV = this.submitVideo.videoHeight
      }
      if (this.submitVideo.currentTime < this.playingMaterial.startTime) {
        this.submitVideo.currentTime = this.playingMaterial.startTime
      }
      this.trackCurrentTime =
        this.submitVideo.currentTime +
        this.playingMaterial.trackStartTime -
        this.playingMaterial.startTime
      this.trackCurrentTimeString = formatDuration(this.trackCurrentTime)
      if (this.trackCurrentTime >= this.trackDuration) {
        this.trackCurrentTime = 0
        this.isEnd = true
      }
      this.getPlayingMaterial()
      this.handleVideoChange()
    },
    playVideoPicture(picture, isNeedPlay) {
      this.$nextTick(() => {
        let videoPicture = this.$refs.pictureDrr[0].$refs.drrTarget[0]
        videoPicture.currentTime =
          this.trackCurrentTime - picture.trackStartTime
        this.$store.commit('drrElementData', {
          way: false,
          index: this.playingPictureIndex[0],
          playingName: 'playingPicture',
          vm: this.$refs.pictureDrr[0]
        })
        // 需要播放视频贴图
        if (isNeedPlay) {
          setTimeout(() => {
            // 避免异步函数在不允许的条件执行 - 非视频播放时不允许贴图播放
            if (this.videoPlay) {
              videoPicture.play()
            }
          }, 150)
        }
      })
    },
    handleVideoPlay() {
      setTimeout(() => {
        // 视频轨道播放
        this.submitVideo.currentTime = this.currentTime
        this.submitVideo.play()
        this.videoPlay = true
        // 转场视频播放
        const drrTarget = this.$refs.pictureDrr[0].$refs.drrTarget
          ? this.$refs.pictureDrr[0].$refs.drrTarget[0]
          : null
        if (drrTarget && this.playingPicture[0].fileType === 'video') {
          const duration =
            this.pointerDuration - this.playingPicture[0].trackStartTime
          if (!isNaN(duration)) {
            drrTarget.currentTime =
              this.pointerDuration - this.playingPicture[0].trackStartTime
            drrTarget.play()
          }
        }
      }, 150)
    },
    handleVideoPause() {
      // 视频轨道暂停
      this.videoPlay = false
      this.submitVideo.pause()
      const drrTarget = this.$refs.pictureDrr[0].$refs.drrTarget
        ? this.$refs.pictureDrr[0].$refs.drrTarget[0]
        : null
      if (drrTarget && this.playingPicture[0].fileType === 'video') {
        // 避免视频贴图播放时暂停后的无法再次播放
        this.oldPictureIndex = null
        drrTarget.pause()
      }
    },
    handleVideoChange() {
      const newUrl = this.playingMaterial.resourceUrl
      const oldUrl = this.lastPlayedMaterial.resourceUrl
      const newTime = this.playingMaterial.trackStartTime
      const oldTime = this.lastPlayedMaterial.trackStartTime
      const current =
        this.playingMaterial.startTime +
        this.trackCurrentTime -
        this.playingMaterial.trackStartTime
      this.currentTime = current
      // 暂停中
      if (!this.videoPlay) {
        this.videoSrc = this.playingMaterial.resourceUrl
        this.submitVideo.currentTime = current
        return 1
      }
      // 播放中 需要更换视频源
      if (newUrl !== oldUrl) {
        this.videoSrc = this.playingMaterial.resourceUrl
        this.submitVideo.src = this.playingMaterial.resourceUrl
        this.submitVideo.currentTime = current
        this.submitVideo.pause()
        setTimeout(() => {
          this.submitVideo.play()
        }, 150)
      }
      // 播放中 无需更换视频源
      if (newUrl === oldUrl && newTime !== oldTime) {
        this.submitVideo.currentTime = current
      }
      // 智能编辑生成作品 实际视频长度与轨道长度不符 播放中 无需更换视频源
      if (this.isEnd) {
        this.submitVideo.currentTime = current
        this.isEnd = false
      }
    },
    handleSliderChange(current) {
      this.trackCurrentTime = current
      this.trackCurrentTimeString = formatDuration(this.trackCurrentTime)
      this.getPlayingMaterial()
      this.handleVideoChange()
      // this.drawCanvasCover()
    },
    handleTagDelete(index) {
      this.form.tag.splice(index, 1)
    },
    handleUploadChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    handleUploadSuccess(index, value) {
      if (index) {
        this.form.picV = value.url
        this.loadingPicV = false
        this.$refs.form.validateField('picV')
      } else {
        this.form.picH = value.url
        this.loadingPicH = false
        this.$refs.form.validateField('picH')
      }
    },
    handleUploadBefore(index, value) {
      if (index) {
        this.loadingPicV = true
      } else {
        this.loadingPicH = true
      }
    },
    handleUploadCanvas(value, target, index) {
      // target: 0 picH, 1 picV, 2 added, 3 selected
      const imageFile = this.transferBase64ToFile(value)
      let form = new FormData()
      form.append('file', imageFile)
      return this.$service.uploadCover(form).then(data => {
        switch (target) {
          case 0:
            this.form.picH = data.url
            break
          case 1:
            this.form.picV = data.url
            break
          case 2:
            this.realAddedList[index].cover = data.url
            break
          case 3:
            this.realSelectedList[index].cover = data.url
            break
        }
        return true
      })
    },
    handleSubmitValid() {
      if (this.loadingSave) {
        return false
      }
      this.videoPlay = false
      this.submitVideo.pause()
      this.$refs.form.validate(valid => {
        if (valid) {
          this.handleVideoSubmit()
        }
      })
    },
    handleVideoSubmit() {
      this.isLoading = true
      this.loadingSave = true
      const params = {
        materialName: this.form.materialName,
        resourceId: this.backImageList[0][0].resourceId,
        spaceId: this.spaceId,
        videoVO: {
          resourceId: this.realVideoList[0][0].resourceId,
          x: this.realVideoList[0][0].nowXAxis * this.backZoom.width,
          y: this.realVideoList[0][0].nowYAxis * this.backZoom.height,
          zoom: this.realVideoList[0][0].width * this.backZoom.width + ':' + this.realVideoList[0][0].height * this.backZoom.height
        },
        watermarkList: this.handleList(this.realPictureList)
      }
      // console.log('视频合成++++++++++++', params)
      this.$service.mergeVideo(params).then(res => {
        this.isLoading = false
        this.loadingSave = false
        this.$emit('all-close')
      }).catch(() => {
        this.isLoading = false
        this.loadingSave = false
      })
    },
    handleList(arr) {
      let list = []
      for (let i = 0; i < arr.length; i++) {
        list = list.concat(arr[i])
      }
      // arr.forEach(item => {
      //   list.concat(item)
      // })
      const res = list.map(item => {
        return {
          endSecond: item.endSecond,
          overturn: item.overturn ? item.overturn : undefined,
          resourceId: item.resourceId,
          resourcePath: item.resourcePath,
          startSecond: item.startSecond,
          transparency: item.transparency,
          whirl: item.whirl,
          x: item.nowXAxis * this.backZoom.width,
          y: item.nowYAxis * this.backZoom.height,
          zoom: item.width * this.backZoom.width + ':' + item.height * this.backZoom.height
        }
      })
      return res
    },
    transferBase64ToFile(base64) {
      let arr = base64.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let str = atob(arr[1])
      let n = str.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = str.charCodeAt(n)
      }
      return new File([u8arr], 'cover.jpg', { type: mime })
    },
    judgeCoverType() {
      const base64 = /base64/
      const picH64 = base64.test(this.form.picH)
      const picV64 = base64.test(this.form.picV)
      let promiseContainer = []
      if (picH64) {
        promiseContainer.push(this.handleUploadCanvas(this.form.picH, 0))
      }
      if (picV64) {
        promiseContainer.push(this.handleUploadCanvas(this.form.picV, 1))
      }
      return Promise.all(promiseContainer)
    },
    formatAllMaterial() {
      this.loadingSave = true
      let promiseContainer = []
      this.realSelectedList.forEach((item, index) => {
        item.startTime = Math.floor(item.startTime)
        item.endTime = Math.floor(item.endTime)
        item.trackStartTime = Math.floor(item.trackStartTime)
        item.trackEndTime = Math.floor(item.trackEndTime)
        item.duration = Math.floor(item.duration)
        if (/base64/.test(item.cover)) {
          promiseContainer.push(this.handleUploadCanvas(item.cover, 3, index))
        }
      })
      this.realAddedList.forEach((item, index) => {
        item.duration = Math.floor(item.duration)
        if (/base64/.test(item.cover)) {
          promiseContainer.push(this.handleUploadCanvas(item.cover, 2, index))
        }
      })
      const tracks = [
        {
          list: 'realPictureList',
          length: this.realPictureList.length
        },
        {
          list: 'realTextList',
          length: this.realTextList.length
        }
      ]
      for (let i = 0; i < tracks.length; i++) {
        const listName = tracks[i].list
        const length = tracks[i].length

        // 无对应轨道素材时
        if (!this[listName] || !length) {
          continue
        }
        const lastMedia = this.realSelectedList[
          this.realSelectedList.length - 1
        ]
        for (let j = 0; j < length; j++) {
          const lastTrackIndex = this[listName][j].findIndex(item => {
            return (
              item.trackStartTime < lastMedia.trackEndTime &&
              item.trackEndTime >= lastMedia.trackEndTime
            )
          })
          if (lastTrackIndex !== -1 && this.saveOrSubmit) {
            this[listName][j].splice(lastTrackIndex + 1)
            this[listName][j][lastTrackIndex].trackEndTime =
              lastMedia.trackEndTime
          }
          this[listName][j].forEach(item => {
            item.startSecond = Math.floor(item.trackStartTime)
            item.endSecond = Math.floor(item.trackEndTime)
            item.xAxis = Math.round(
              (this.form.firstVideoH / this.videoFrame.width) * item.nowXAxis
            )
            item.yAxis = Math.round(
              (this.form.firstVideoV / this.videoFrame.height) * item.nowYAxis
            )
            const width = Math.round(
              (this.form.firstVideoH / this.videoFrame.width) * item.width
            )
            const height = Math.round(
              (this.form.firstVideoV / this.videoFrame.height) * item.height
            )
            if (listName === 'realPictureList') {
              item.mergeZoom = width + ':' + height
              item.watermark = item.fileUrl
            }
          })
        }
      }
      return Promise.all(promiseContainer).finally(() => {
        this.loadingSave = false
      })
    },
    getPlayingMaterial() {
      this.lastPlayedMaterial = Object.assign({}, this.playingMaterial)
      this.tracks.forEach(track => {
        this.getPlaying(track)
      })
    },
    getPlaying(track) {
      const trackCurrentTime = this.trackCurrentTime
      const list = track.list
      const target = track.target
      let index = null
      // if (list === 'realTransitionList') {
      //   this[list] = Various.transitionList
      // }
      // 兼容未多轨道化的视频轨道
      if (list === 'realSelectedList') {
        index = this[list].findIndex(item => {
          return (
            item.trackStartTime <= trackCurrentTime &&
            item.trackEndTime > trackCurrentTime
          )
        })
        this[target] = index === -1 ? undefined : this[list][index]
        // 避免手动移到播放末尾造成的再播放错误问题
        if (!this[target]) {
          this[target] = this[list][0]
        }
      } else {
        let tempTargetList = []
        let tempIndexIndex = []
        for (let i = 0; i < this[list].length; i++) {
          if (!this[list][i]) {
            continue
          }
          index = this[list][i].findIndex(item => {
            return (
              item.trackStartTime <= trackCurrentTime &&
              item.trackEndTime > trackCurrentTime
            )
          })
          const target = index === -1 ? undefined : this[list][i][index]
          tempTargetList.push(target)
          tempIndexIndex.push(index)
        }
        this[target] = tempTargetList
        this[target + 'Index'] = tempIndexIndex
      }
    },
    getSaveParams() {
      let params = { ...this.form }
      params.tag = this.form.tag.toString()
      params.rlsList = this.realSelectedList
      params.rlsVideos = this.realAddedList
      // 贴图轨道实际上为单轨
      params.pics = this.realPictureList[0]
      params.transitionsDTOS = Various.transitionList
      params.textDTOS = this.realTextList
      return params
    },
    getCoverByVideo() {
      let canvasH = document.createElement('canvas')
      let canvasV = document.createElement('canvas')
      let video = this.submitVideo
      const vWidth = video.videoWidth / 3
      const vheight = video.videoHeight
      canvasH.width = 640
      canvasH.height = 360
      canvasV.width = 640 / 3
      canvasV.height = 360
      canvasH
        .getContext('2d')
        .drawImage(video, 0, 0, canvasH.width, canvasH.height)
      canvasV
        .getContext('2d')
        .drawImage(
          video,
          vWidth,
          0,
          vWidth,
          vheight,
          0,
          0,
          canvasV.width,
          canvasV.height
        )
      this.form.picH = canvasH.toDataURL('image/jpeg')
      this.form.picV = canvasV.toDataURL('image/jpeg')
      this.$refs.form.validateField('picV')
      this.$refs.form.validateField('picH')
    },
    getReverseIndex(index, length) {
      return length - 1 + index + index * -2
    },
    getAdviceTag() {
      // 获取非本地上传素材的coocaaVId
      const target = this.realSelectedList.find(item => {
        return item.coocaaVId * 1 !== -1
      })
      this.$service
        .getAdviceTag({ coocaaVId: target.coocaaVId })
        .then(data => {
          if (!data.data.length) {
            this.$message({
              type: 'warning',
              message: '素材暂无智能标签'
            })
          } else {
            this.$message({
              type: 'success',
              message: '智能标签获取成功，已进行重复剔除'
            })
            // 剔除重复标签
            const list = data.data.split(',')
            for (let i = 0; i < list.length; i++) {
              const tag = this.form.tag.find(item => {
                return list[i] === item
              })
              if (!tag) {
                this.form.tag.push(list[i])
              }
            }
          }
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '素材暂无智能标签'
          })
        })
    },
    initForm() {
      this.form = { ...this.formInfo }
      if (this.form.tag.length === 1 && this.form.tag[0] === '') {
        this.form.tag.pop()
      }
      this.isLoadingSelect = false
    },
    initData() {
      let lastMaterial = this.realSelectedList[this.realSelectedList.length - 1]
      this.form.videoType = this.saveOrSubmit
      this.form.duration = lastMaterial.trackEndTime
      this.trackDuration = Math.floor(lastMaterial.trackEndTime)
      this.playingMaterial = this.realSelectedList[0]
      this.videoSrc = this.realSelectedList[0].resourceUrl
      this.currentTime = Math.round(this.realSelectedList[0].startTime)
    },
    initDrrScale() {
      this.widthScale = 530 / this.videoFrame.width
      this.heightScale = 298 / this.videoFrame.height
    },
    stopCanvasVideo() {
      clearInterval(this.canvasTimer)
    },
    drawCanvasVideo() {
      let canvasVideo = this.canvasVideo
      let ctx = canvasVideo.getContext('2d')
      let video = this.submitVideo
      // let videoTransition = this.$refs.videoTransition
      canvasVideo.width = 1280
      canvasVideo.height = 720
      this.canvasTimer = setInterval(() => {
        ctx.drawImage(video, 0, 0, canvasVideo.width, canvasVideo.height)
      }, 40)
    },
    drawCanvasCover() {
      let canvasVideo = this.canvasVideo
      let ctx = canvasVideo.getContext('2d')
      let video = this.submitVideo
      canvasVideo.width = 1280
      canvasVideo.height = 720
      ctx.drawImage(video, 0, 0, canvasVideo.width, canvasVideo.height)
      this.isVideoLoading = false
    },
    drawBackImage() {
      let canvasBackImage = this.canvasBackImage
      const ctx = canvasBackImage.getContext('2d')
      const backImage = new Image()
      canvasBackImage.width = this.videoFrame.width
      canvasBackImage.height = this.videoFrame.height
      backImage.onload = function () {
        ctx.drawImage(backImage, 0, 0, canvasBackImage.width, canvasBackImage.height)
      }
      backImage.src = this.backImageList[0][0].resourceUrl
      setTimeout(() => {
        this.handleVideoPlay()
      }, 500)
    }
  },
  created() {
    const tempArr = []
    this.realSelectedList = tempArr.concat(this.selectedMaterialList)
    this.realAddedList = tempArr.concat(this.addedMaterialList)
    this.realPictureList = this.pictureTrackList
      ? JSON.parse(JSON.stringify(this.pictureTrackList)).reverse()
      : []
    this.realTextList = this.textTrackList
      ? JSON.parse(JSON.stringify(this.textTrackList))
      : []
    this.realVideoList = this.videoReource ? JSON.parse(JSON.stringify(this.videoReource)) : [[]]
    this.formatAllMaterial()
  },
  mounted() {
    this.initData()
    this.$nextTick(() => {
      this.submitVideo = this.$refs.videoDrr[0].$refs.drrTarget[0]
      this.canvasVideo = this.$refs.canvasVideo
      this.canvasBackImage = this.$refs.canvasBackImage
      if (!this.isHighlight) {
        this.initDrrScale()
      }
      this.drawBackImage()
      this.submitVideo.addEventListener('timeupdate', this.handleVideoPlaying)
    })
  },
  beforeDestroy() {
    this.submitVideo.removeEventListener(
      'timeupdate',
      this.handleVideoPlaying
    )
  }
}
</script>
<style lang="stylus" scoped>
.submit-video-container
  padding 0px !important
  position relative
  // min-height 400px
  // width 528px
  // width 640px
.video-frame
  width inherit
  // height 360px
  canvas
    width 100%
    height 100%
.submit-video
  width 100%
  height 100%
.resizable-container
  position absolute
  top 0px
  width inherit
  // height 370px
  overflow hidden
.resizable-style
  position absolute
  z-index 2
  video
    width inherit
    height inherit
    object-fit fill
  .el-image
    width inherit
    height inherit
.video-controls
  position relative
  margin-top 10px
.controls-icons
  >>>.el-image
    width 18px
    height 18px
    cursor pointer
.controls-duration
  position absolute
  top 0px
  left 30px
.video-slider
  >>>.el-slider__button
    width 10px !important
    height 10px !important
.auto-tag-button
  margin-right 10px
.message
  font-size 12px
  color #ccc
  cursor default
.tags-container
  margin-top 18px
  padding-left 90px
.dialog-tag
  display inline-block
  margin 0px 20px 10px 0px
  padding 0px 12px
  height 25px
  line-height 25px
  font-size 13px
  color #ef6139
  border 1px solid #ccc
  border-radius 5px
  background #f2f2f2
.el-icon-close
  cursor pointer
.tag-input
  padding-left 90px
  width -webkit-fill-available
.my-error
  margin-left 90px
.cover-source
  margin-right 20px
  vertical-align top
  .cover-by-canvas
    cursor pointer
    &:hover,
    &:focus
      color #409eff
.avatar-uploader
  display inline-block
  margin-right 10px
  border 1px dashed #d9d9d9
  border-radius 6px
  overflow hidden
  cursor pointer
  &:hover,
  &:focus
    border-color #409eff
.horizontal-cover-uploader
  margin-left 90px
.horizontal-cover-uploader, .horizontal-cover, .horizontal-cover-icon
  width 203px
  height 114px
.vertical-cover-uploader, .vertical-cover, .vertical-cover-icon
  width 68px
  height 114px
.el-icon-plus
  line-height 114px
  font-size 28px
  color #333
  &:hover,
  &:focus
    color #409eff
.pic-style
  display inline-block
  margin-bottom 0px
.cover-message
  padding-left 90px
.submit-button-group
  text-align center
</style>
<style lang="stylus" scoped>
.submit-dialog
  >>>.el-dialog
    margin-top 5vh !important
    // height 90vh
    border-radius 10px
    .el-dialog__body
      padding 30px 10px
      height auto
.input-inner
  >>>.el-input__inner
    border 0px
    border-bottom 1px solid #000
    border-radius 0px
  >>>.el-form-item__content
    display inline-block
// >>>.el-form
//   .el-form-item__label
//     width 95px
//     text-align right
//   .el-form-item__error
//     left 90px
//     width max-content
// .works-title
//   >>>.el-form-item__error
//     left 0px
// .picV-style
//   >>>.el-form-item__error
//     left 0px
// .pic-style
//   >>>.el-form-item__error
//     margin-top -10px
</style>
